import React from 'react';

export class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: '' };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, errorMessage: error.message || '' };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        const errorString = (error.message || '').toLowerCase();
        const isChunkError = error.name === 'ChunkLoadError' || 
                             errorString.includes('failed to fetch dynamically imported module') ||
                             errorString.includes('importing a module script failed');
        
        if (isChunkError) {
            // Recarga automática para traer los chunks nuevos tras un deploy -- pero UNA sola
            // vez por pestaña cada 10s: si el chunk sigue fallando tras recargar (CDN sirviendo
            // el index.html viejo, red caída) recargar en bucle deja la página "recargándose
            // sola" sin fin. Pasado ese punto se muestra el fallback con el botón manual.
            const KEY = 'colonny:last-chunk-reload';
            let last = 0;
            try { last = Number(sessionStorage.getItem(KEY)) || 0; } catch { /* modo privado */ }
            if (Date.now() - last > 10000) {
                try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* modo privado */ }
                window.location.reload();
            }
        }
    }

    render() {
        if (this.state.hasError) {
            // Si no fue un error de chunk (que recarga automáticamente), mostramos un fallback
            return (
                <div style={{ padding: '20px', color: '#fff', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%', background: '#09090b' }}>
                    <h3 style={{ marginBottom: '10px' }}>Error Inesperado</h3>
                    <p style={{ color: '#888', marginBottom: '20px', fontSize: '13px', maxWidth: '400px' }}>{this.state.errorMessage}</p>
                    <button 
                        onClick={() => window.location.reload()} 
                        style={{ padding: '8px 16px', background: '#333', color: '#fff', border: '1px solid #444', borderRadius: '4px', cursor: 'pointer' }}
                    >
                        Recargar Aplicación
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
